import React, { useState, useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';
import backgroundImage from './images/hawaii.JPG';

const Home = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Box
      sx={{
        height: { xs: 'auto', sm: '100vh' },
        minHeight: { xs: '100vh', sm: 'auto' },
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: { xs: 'scroll', sm: 'fixed' },
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* Animated Overlay */}
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          backdropFilter: 'blur(2px)',
          zIndex: 1,
        }}
      />

      {/* Main Content */}
      <Box
        sx={{
          flex: 1,
          position: 'relative',
          zIndex: 2,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          transform: `translateY(${scrollY * 0.5}px)`,
        }}
      >
        <Box
          sx={{
            textAlign: 'center',
            color: 'white',
            animation: 'fadeInUp 1s ease-out both',
            px: 2,
            '@keyframes fadeInUp': {
              from: { opacity: 0, transform: 'translateY(30px)' },
              to: { opacity: 1, transform: 'translateY(0)' },
            },
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontWeight: 700,
              fontSize: { xs: '2.5rem', sm: '4rem', md: '5rem' },
              m: 0,
              letterSpacing: 'normal',
              textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
              lineHeight: 1.1,
              color: 'white',
              fontFamily: 'system-ui, -apple-system, sans-serif',
            }}
          >
            TX Park Hoppers
          </Typography>

          <Box
            sx={{
              height: '4px',
              width: '80px',
              backgroundColor: '#4CAF50',
              mx: 'auto',
              my: 2,
              borderRadius: '2px',
              animation: 'slideIn 1s ease-out 0.3s both',
              '@keyframes slideIn': {
                from: { width: 0, opacity: 0 },
                to: { width: '80px', opacity: 1 },
              },
            }}
          />

          <Typography
            variant="h5"
            sx={{
              fontWeight: 400,
              mt: 3,
              fontSize: { xs: '1.1rem', sm: '1.5rem' },
              color: '#f8f9fa',
              maxWidth: '700px',
              mx: 'auto',
              textShadow: '1px 1px 3px rgba(0,0,0,0.5)',
              lineHeight: 1.5,
              letterSpacing: 'normal',
              animation: 'fadeInUp 1s ease-out 0.2s both',
              fontFamily: 'system-ui, -apple-system, sans-serif',
            }}
          >
            Trail Hopping Across Texas State Parks & U.S. National Parks
          </Typography>

          <Box sx={{ mt: { xs: 4, sm: 5 }, display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              href="/about"
              sx={{
                backgroundColor: '#4CAF50',
                color: 'white',
                px: { xs: 3, sm: 4 },
                py: { xs: 1.2, sm: 1.8 },
                fontSize: { xs: '0.95rem', sm: '1.1rem' },
                fontWeight: 700,
                textTransform: 'none',
                borderRadius: '50px',
                boxShadow: '0 6px 20px rgba(76, 175, 80, 0.4)',
                '&:hover': {
                  backgroundColor: '#45a049',
                  transform: 'translateY(-4px)',
                  boxShadow: '0 8px 25px rgba(76, 175, 80, 0.6)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              About Us
            </Button>
            <Button
              variant="outlined"
              href="/tx-state-parks"
              sx={{
                borderColor: 'white',
                color: 'white',
                px: { xs: 3, sm: 4 },
                py: { xs: 1.2, sm: 1.8 },
                fontSize: { xs: '0.95rem', sm: '1.1rem' },
                fontWeight: 600,
                textTransform: 'none',
                borderRadius: '50px',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.2)',
                  transform: 'translateY(-4px)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              View TX State Parks
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Home;
